var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonbase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11011_55514)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 40,
    height: 40,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 39,
    height: 39,
    rx: 7.5,
    stroke: "#D0D5DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6558 13.3854C29.4827 13.2135 29.2655 13.0926 29.0281 13.0361C28.7908 12.9796 28.5424 12.9896 28.3104 13.065L14.9199 17.5316C14.6715 17.6103 14.4521 17.7608 14.2892 17.9641C14.1264 18.1675 14.0275 18.4145 14.0049 18.674C13.9824 18.9336 14.0373 19.194 14.1627 19.4223C14.2881 19.6507 14.4783 19.8368 14.7094 19.9571L20.2651 22.7029L23.0109 28.2769C23.1213 28.4951 23.2902 28.6783 23.4987 28.806C23.7072 28.9337 23.9471 29.0008 24.1916 29H24.2832C24.545 28.9807 24.795 28.8831 25.0007 28.7199C25.2063 28.5567 25.3582 28.3354 25.4364 28.0847L29.967 14.7308C30.0479 14.5001 30.0616 14.2512 30.0065 14.013C29.9514 13.7748 29.8298 13.5571 29.6558 13.3854ZM15.4873 18.7947L27.1754 14.8956L20.6861 21.3849L15.4873 18.7947ZM24.2557 27.5539L21.6563 22.3551L28.1456 15.8658L24.2557 27.5539Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11011_55514",
    x: 0,
    y: 0,
    width: 44,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11011_55514"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11011_55514",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonbase);
export default __webpack_public_path__ + "static/media/_Button base.7f5a214a56a4562f5ea9ec728cb8e7cd.svg";
export { ForwardRef as ReactComponent };